import { Injectable } from '@angular/core';
import {IPayrollProvider} from '../models/customer.model';

@Injectable({
  providedIn: 'root'
})
export class PayrollProvidersService {

  public payrollProviders: IPayrollProvider[] = [];

  constructor() { }

  setPayrollProviders(providers: IPayrollProvider[]) {
    this.payrollProviders = providers;
  }
}
